export const listenAccordion = (className) => {
  const accordions = document.querySelectorAll(className);

  [...accordions].forEach((accordion) => {
    const buttons = accordion.querySelectorAll('button');

    [...buttons].forEach((button) => {
      button.onclick = (e) => {
        const parent = e.currentTarget.parentElement;
        parent.classList.toggle('active');
        $(parent.querySelector('ul')).slideToggle(300);
      };
    });
  });
};
